export function getFormattedDate(date: string): string {
  const dateVal = new Date(date);
  return `${dateVal.getFullYear()}-${(dateVal.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${dateVal.getDate().toString().padStart(2, '0')}`;
}

export const getFormattedNumber = (num: number): string =>
  new Intl.NumberFormat().format(num);

export const getFormattedText = (text?: string | null): string => {
  if (!text) {
    return '';
  }

  return text.charAt(0).toUpperCase() + text.slice(1);
};

export function getFormattedDateUTC(year: number, month: string): string {
  return `${year}-${month.toString().padStart(2, '0')}-01`;
}
